/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetResellerTargetByIdDto } from '../models/custom-result-of-get-reseller-target-by-id-dto';
import { CustomResultOfPaginatedListOfGetResellerTargetsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-reseller-targets-with-pagination-dto';
import { resellerTargetCreateGet } from '../fn/reseller-target/reseller-target-create-get';
import { ResellerTargetCreateGet$Params } from '../fn/reseller-target/reseller-target-create-get';
import { resellerTargetCreatePost } from '../fn/reseller-target/reseller-target-create-post';
import { ResellerTargetCreatePost$Params } from '../fn/reseller-target/reseller-target-create-post';
import { resellerTargetDelete } from '../fn/reseller-target/reseller-target-delete';
import { ResellerTargetDelete$Params } from '../fn/reseller-target/reseller-target-delete';
import { resellerTargetGetResellerTargetAuditWithPagination } from '../fn/reseller-target/reseller-target-get-reseller-target-audit-with-pagination';
import { ResellerTargetGetResellerTargetAuditWithPagination$Params } from '../fn/reseller-target/reseller-target-get-reseller-target-audit-with-pagination';
import { resellerTargetGetResellerTargetsWithPagination } from '../fn/reseller-target/reseller-target-get-reseller-targets-with-pagination';
import { ResellerTargetGetResellerTargetsWithPagination$Params } from '../fn/reseller-target/reseller-target-get-reseller-targets-with-pagination';
import { resellerTargetUpdateGet } from '../fn/reseller-target/reseller-target-update-get';
import { ResellerTargetUpdateGet$Params } from '../fn/reseller-target/reseller-target-update-get';
import { resellerTargetUpdatePut } from '../fn/reseller-target/reseller-target-update-put';
import { ResellerTargetUpdatePut$Params } from '../fn/reseller-target/reseller-target-update-put';

@Injectable({ providedIn: 'root' })
export class ResellerTargetService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `resellerTargetCreateGet()` */
  static readonly ResellerTargetCreateGetPath = '/ResellerTarget/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellerTargetCreateGet$Response(params?: ResellerTargetCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return resellerTargetCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellerTargetCreateGet(params?: ResellerTargetCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.resellerTargetCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `resellerTargetCreatePost()` */
  static readonly ResellerTargetCreatePostPath = '/ResellerTarget/Create';

  /**
   * Create Reseller Target.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetCreatePost$Response(params: ResellerTargetCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return resellerTargetCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Reseller Target.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetCreatePost(params: ResellerTargetCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.resellerTargetCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `resellerTargetUpdateGet()` */
  static readonly ResellerTargetUpdateGetPath = '/ResellerTarget/Update';

  /**
   * Get Reseller Target By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellerTargetUpdateGet$Response(params?: ResellerTargetUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetResellerTargetByIdDto>> {
    return resellerTargetUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller Target By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellerTargetUpdateGet(params?: ResellerTargetUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetResellerTargetByIdDto> {
    return this.resellerTargetUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetResellerTargetByIdDto>): CustomResultOfGetResellerTargetByIdDto => r.body)
    );
  }

  /** Path part for operation `resellerTargetUpdatePut()` */
  static readonly ResellerTargetUpdatePutPath = '/ResellerTarget/Update';

  /**
   * Update Reseller Target.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetUpdatePut$Response(params: ResellerTargetUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return resellerTargetUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Reseller Target.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetUpdatePut(params: ResellerTargetUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.resellerTargetUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `resellerTargetDelete()` */
  static readonly ResellerTargetDeletePath = '/ResellerTarget/Delete';

  /**
   * Delete Reseller Target.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellerTargetDelete$Response(params?: ResellerTargetDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return resellerTargetDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Reseller Target.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resellerTargetDelete(params?: ResellerTargetDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.resellerTargetDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `resellerTargetGetResellerTargetsWithPagination()` */
  static readonly ResellerTargetGetResellerTargetsWithPaginationPath = '/ResellerTarget/GetResellerTargetsWithPagination';

  /**
   * Get Reseller Targets With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetGetResellerTargetsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetGetResellerTargetsWithPagination$Response(params: ResellerTargetGetResellerTargetsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerTargetsWithPaginationDto>> {
    return resellerTargetGetResellerTargetsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller Targets With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetGetResellerTargetsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetGetResellerTargetsWithPagination(params: ResellerTargetGetResellerTargetsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetResellerTargetsWithPaginationDto> {
    return this.resellerTargetGetResellerTargetsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetResellerTargetsWithPaginationDto>): CustomResultOfPaginatedListOfGetResellerTargetsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `resellerTargetGetResellerTargetAuditWithPagination()` */
  static readonly ResellerTargetGetResellerTargetAuditWithPaginationPath = '/ResellerTarget/GetResellerTargetAuditWithPagination';

  /**
   * Get Reseller Target Audit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resellerTargetGetResellerTargetAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetGetResellerTargetAuditWithPagination$Response(params: ResellerTargetGetResellerTargetAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return resellerTargetGetResellerTargetAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Reseller Target Audit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resellerTargetGetResellerTargetAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resellerTargetGetResellerTargetAuditWithPagination(params: ResellerTargetGetResellerTargetAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.resellerTargetGetResellerTargetAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
